/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type LinkedInChatResponseDraftStatus = typeof LinkedInChatResponseDraftStatus[keyof typeof LinkedInChatResponseDraftStatus] | null;


export const LinkedInChatResponseDraftStatus = {
  generating: 'generating',
  ready: 'ready',
  accepted: 'accepted',
  denied: 'denied',
  failed: 'failed',
} as const;
